// extracted by mini-css-extract-plugin
module.exports = {"container":"ag_e"};